import { addMethod, object } from 'yup';

// Sets the default to `{}` and transforms `null` and `undefined` values to an empty object.
// Similar in functionality to Yup's built-in `array.ensure()` and `string.ensure()`.
function objEnsure() {
  return this.default({}).transform((val) => (val == null ? {} : val));
}
addMethod(object, 'ensure', objEnsure);
